import styled, { css } from 'styled-components';
import { getColor } from 'utils/colorUtility';
import { Col, Row } from 'components/Core/Grid';
import { HERO_PADDING_WITH_BREADCRUMBS } from 'styles/STtheme/styled';

const backgroundStyles = css`
  background-image: ${({ gradientDirection }) => {
    return `${
      gradientDirection
        ? `linear-gradient(${gradientDirection.toLowerCase()}, rgba(0,0,0,1) 0%, rgba(0,212,255,0) 78%),`
        : ''
    }`;
  }};
  background-color: ${({ $backgroundColor, $customBackgroundDesktop, $customBackgroundMobile }) => {
    return $backgroundColor && $backgroundColor !== 'Choose a value'
      ? getColor($backgroundColor)
      : $customBackgroundDesktop || $customBackgroundMobile;
  }};
  background-size: cover;
  background-repeat: no-repeat;
  padding: ${({ $fullWidthBackground, $paddingDesktop, $paddingMobile }) =>
    $paddingDesktop || $paddingMobile || $fullWidthBackground ? '75px 0' : '75px'};

  @media (max-width: 767px) {
    background-color: ${({ $backgroundColor, $customBackgroundMobile }) =>
      $backgroundColor ? getColor($backgroundColor) : $customBackgroundMobile};
    padding: ${({ $paddingMobile }) => $paddingMobile || '75px 28px !important'};
  }
`;

const SectionContainer = styled.div`
  position: relative;

  .styles-container {
    overflow-x: clip;

    ${({ $isHero }) => ($isHero ? 'padding-top: 0px !important;' : '')};
  }
`;

const SectionInnerContainer = styled.div`
  width: 100%;
  ${({ $showBreadcrumbs, $isHero }) =>
    $showBreadcrumbs
      ? HERO_PADDING_WITH_BREADCRUMBS
      : $isHero
      ? `
    padding-top: 150px;
    @media (max-width: 1450px) {
      padding-top: 140px;
    }
    @media (max-width: 1199px) {
      padding-top: 100px;
    }
  `
      : 'padding-top: 0'};
`;

const InnerContainerCol = styled(Col)`
  ${({
    $backgroundColor,
    $customBackgroundMobile,
    $customBackgroundDesktop,
    $fullWidthBackground,
  }) =>
    ($backgroundColor || $customBackgroundDesktop || $customBackgroundMobile) &&
    !$fullWidthBackground &&
    backgroundStyles};
  max-width: ${({ $fullWidth }) => ($fullWidth ? '100%' : '1196px !important')};

  width: 100% !important;
`;

const SectionContainerRow = styled(Row)`
  display: ${({ $displayDesktop }) => `${$displayDesktop} !important`};
  margin: ${({ $isHero, $spacing, $marginDesktop }) => {
    return $marginDesktop
      ? '0 !important'
      : $spacing === 'Double Top'
      ? '120px 0 50px 0 !important'
      : $spacing === 'Double Bottom'
      ? '50px 0 120px 0 !important'
      : $spacing === 'None' || $isHero
      ? '0 !important'
      : '50px 0 !important';
  }};

  padding: ${({ $fullWidth, $isHero, $paddingDesktop }) => {
    if ($paddingDesktop) return '0';
    if ($isHero) {
      return '75px 28px !important';
    }
    return !$fullWidth ? '0 28px' : '0';
  }};

  width: 100%;

  ${({
    $backgroundColor,
    $fullWidthBackground,
    $customBackgroundMobile,
    $customBackgroundDesktop,
  }) =>
    ($backgroundColor || $customBackgroundDesktop || $customBackgroundMobile) &&
    $fullWidthBackground &&
    backgroundStyles};

  @media (max-width: 1199px) {
    padding: ${({ $paddingDesktop, $fullWidth }) => {
      if ($paddingDesktop) return '0';
      return !$fullWidth ? '0 28px' : '0';
    }};
  }

  @media (max-width: 575px) {
    display: ${({ $displayMobile }) => `${$displayMobile} !important`};
    margin: ${({ $isHero, $spacing, $marginMobile }) =>
      $marginMobile
        ? '0'
        : $spacing === 'Double Top'
        ? '60px 0 30px 0 !important'
        : $spacing === 'Double Bottom'
        ? '30px 0 60px 0 !important'
        : $spacing === 'None' || $isHero
        ? '0 !important'
        : '15px 0 !important'};

    padding: ${({ $paddingMobile }) => {
      if ($paddingMobile) return '0';
      return '15px 28px';
    }};
    overflow: hidden;
  }

  &.hero-section-container-row {
    padding-top: 75px !important;

    @media (max-width: 575px) {
      padding-top: 50px !important;
    }

    ${({ $isHero }) =>
      $isHero &&
      `
      .row-container--container {
        padding-top: 0 !important;
  
        .styled-row {
          margin-top: 0 !important;
        }
      }
    `}
  }
`;

export { InnerContainerCol, SectionContainerRow, SectionContainer, SectionInnerContainer };
